import { render } from "./FormDialogsTest.vue?vue&type=template&id=85a98dc8"
import script from "./FormDialogsTest.vue?vue&type=script&lang=js"
export * from "./FormDialogsTest.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__